import axios from '@/services/servicio-base';

const servicioMiListaPedidos = {};
//const url = config.apiUrl

servicioMiListaPedidos.obtenerListaPedidos = function() {
    return axios.post('/mi-lista-pedidos/obtener-lista')
   .then(r => {
      return r.data;
   })
   .catch(e => {
      return e;
   })
}

export default servicioMiListaPedidos;